'use strict';

angular.module('app')
    .service('StarPrinterService', ['$locale', '$q', '$translate', 'PrinterService', function ($locale, $q, $translate, PrinterService) {
        this.builder = new StarWebPrintBuilder();

        this.CutTypes = {
            FULL: 'full',
            PARTIAL: 'partial'
        };

        this.Alignments = {
            LEFT: 'left',
            CENTER: 'center',
            RIGHT: 'right'
        };

        this.LineSpace = {
            SMALL: 24,
            LARGE: 32
        };
        
        var deferred;

        this.initializePrintRequest = function (url, paperType, printerIpAddress, reset, print) {
            var printAddress = PrinterService.getPrintRequestAddress(printerIpAddress);
            var fullUrl = printAddress + '/StarWebPRNT/SendMessage';
            this.request = this.builder.createInitializationElement({reset: reset, print: print});
            this.trader = new StarWebPrintTrader({url: fullUrl, papertype: paperType, timeout: 10000});
            this.trader.onReceive = this.onReceive.bind(this);
            this.trader.onError = function (response) {
                if (response.status === 0 && response.responseText === '') {
                    deferred.reject($translate.instant('recipeViewer.print.errorMsg.unableToConnect'));
                }
            };
        };

        this.sendMessage = function () {
            this.trader.sendMessage({request: this.request});
        };

        this.feed = function (line, unit) {
            this.addToRequest(this.builder.createFeedElement({line: line, unit: unit}));
        };

        this.cutPaper = function (type, feed) {
            this.addToRequest(this.builder.createCutPaperElement({type: type, feed: feed}));
        };

        this.align = function (position) {
            /**
             *    Specifies position alignment
             'left' … Left alignment
             'center' … Center alignment
             'right' … Right alignment
             */
            this.addToRequest(this.builder.createAlignmentElement({position: position}));
        };


        this.addFormFeed = function () {
            this.addToRequest(this.builder.createRawDataElement({data: '\x0c'}));
        };

        this.addText = function (data, characterSpace, lineSpace, width, height) {
            /**
             * characterspace    Specifies character space (Unit of dot)
             * linespace    Specifies line space (Unit of dot)
             24 … Specifies 3mm line feed amount
             32 … Specifies 4mm line feed amount
             * width    Specifies expanded width
             1 … Cancels expanded width
             2 … Specifies 2x width expansion
             3 … Specifies 3x width expansion
             4 … Specifies 4x width expansion
             5 … Specifies 5x width expansion
             6 … Specifies 6x width expansion
             Number    Unchanged
             height    Specifies expanded height
             1 … Cancels expanded height
             2 … Specifies 2x height expansion
             3 … Specifies 3x height expansion
             4 … Specifies 4x height expansion
             5 … Specifies 5x height expansion
             6 … Specifies 6x height expansion
             */
            this.addToRequest(this.builder.createTextElement({
                characterspace: characterSpace, data: data,
                linespace: lineSpace, width: width, height: height
            }));
        };

        this.addTextLine = function (data, characterSpace, lineSpace, width, height) {
            this.addToRequest(this.builder.createTextElement({
                characterspace: characterSpace, data: data,
                linespace: lineSpace, width: width, height: height
            }));
            this.feed(1);
        };

        this.addToRequest = function (addition) {
            this.request += addition;
        };

        this.getCurrentRequest = function () {
            var xmlRequest = "<root";
            var paperType = this.request.paperType ? this.request.paperType : this.trader.papertype;
            switch (paperType) {
                case "normal":
                    xmlRequest += ' papertype="normal"';
                    break;
                case 'black_mark':
                    xmlRequest += ' papertype="black_mark"';
                    break;
                case "black_mark_and_detect_at_power_on":
                    xmlRequest += ' papertype="black_mark_and_detect_at_power_on"';
                    break;
                default:
                    break;
            }
            xmlRequest = xmlRequest + (">" + this.request + "</root>");
            var beginning = '<StarWebPrint xmlns="http://www.star-m.jp" xmlns:i="http://www.w3.org/2001/XMLSchema-instance"><Request>';
            xmlRequest = beginning + xmlRequest;
            xmlRequest += "</Request>";
            xmlRequest += "</StarWebPrint>";
            return xmlRequest;
        };

        this.onReceive = function (response) {
            if (!JSON.parse(response.traderSuccess)) {
                var errorMessage = $translate.instant('recipeViewer.print.errorMsg.somethingWentWrong');
                if (this.trader.isCoverOpen({traderStatus: response.traderStatus})) {
                    errorMessage += $translate.instant('recipeViewer.print.errorMsg.coverIsNotOpen');
                } else if (this.trader.isAutoCutterError({traderStatus: response.traderStatus})) {
                    errorMessage += $translate.instant('recipeViewer.print.errorMsg.paperCutterNotJammed');
                } else if (this.trader.isBlackMarkError({traderStatus: response.traderStatus})
                    || this.trader.isPaperEnd({traderStatus: response.traderStatus})) {
                    errorMessage += $translate.instant('recipeViewer.print.errorMsg.hasEnoughLabelPaper');
                } else if (this.trader.isOffLine({traderStatus: response.traderStatus})) {
                    errorMessage += $translate.instant('recipeViewer.print.errorMsg.printerOnlineWithCorrectIpAddress');
                } else {
                    errorMessage += '';
                }
                deferred.reject(errorMessage);
            } else {
                deferred.resolve('SUCCESS');
            }
        };

        this.printTimestamp = function (printerConfig, prepChef, date, name, quantity) {
            deferred = $q.defer();
            this.initializePrintRequest('/StarWebPRNT/SendMessage', 'black_mark', printerConfig.printerIpAddress);
            this.align(this.Alignments.CENTER);
            
            var chefPrefix = $translate.instant('recipeViewer.print.prefix.chef');
            var recipeNamePrefix = $translate.instant('recipeViewer.print.prefix.recipeName');
            var datePrefix = $translate.instant('recipeViewer.print.prefix.date');
            
            for (var i = 0; i < quantity; i++) {
                if (prepChef) {
                    this.addTextLine(chefPrefix + prepChef, 1, null, 2, 2);
                }
                if (name) {
                    this.addTextLine(recipeNamePrefix + name, 1, null, 2, 2);
                }
                this.addTextLine(datePrefix + PrinterService.getDateStr(date), 1, null, 2, 2);
                if (i < quantity - 1) {
                    this.addFormFeed();
                }
            }
            this.cutPaper(this.CutTypes.FULL, true);
            this.sendMessage();
            return deferred.promise;
        };

        this.printRecipeWithPrintHistory = function (recipePrintHistory, recipeName) {
            deferred = $q.defer();
            this.printRecipe(recipePrintHistory.printerConfig.printerIpAddress, recipePrintHistory.prepChef,
                recipePrintHistory.batchNumber, recipePrintHistory.prepDate, recipePrintHistory.expireDate,
                recipePrintHistory.notes, recipePrintHistory.quantity, recipeName);
            return deferred.promise;
        };

        this.printRecipe = function (printerIpAddress, prepChef, batchNumber, prepDate, expireDate, notes, quantity, recipeName) {
            this.currentIP = printerIpAddress;
            var expireDayOfWeek = expireDate ? $locale.DATETIME_FORMATS.DAY[expireDate.getDay()] : null;
            this.initializePrintRequest('/StarWebPRNT/SendMessage', 'black_mark', printerIpAddress);
            
            var prepChefPrefix = $translate.instant('recipeViewer.print.prefix.prepChef');
            var batchNumberPrefix = $translate.instant('recipeViewer.print.prefix.batchNumber');
            var prepDayPrefix = $translate.instant('recipeViewer.print.prefix.prepDay');
            var expiresPrefix = $translate.instant('recipeViewer.print.prefix.expires');
            var notesPrefix = $translate.instant('recipeViewer.print.prefix.notes');
            
            for (var i = 0; i < quantity; i++) {
                this.align(this.Alignments.CENTER);
                this.addTextLine(recipeName, 1, null, 2, 2);
                this.addTextLine(prepChefPrefix + prepChef, 1, null, 1, 1);
                this.addTextLine(batchNumberPrefix + batchNumber);
                this.addTextLine(prepDayPrefix + PrinterService.getDateStr(prepDate));
                if (expireDate) {
                    this.addTextLine(expiresPrefix + PrinterService.getDateStr(expireDate));
                }
                if (notes) {
                    this.addTextLine(notesPrefix + notes);
                }
                if (expireDate) {
                    this.addText(expireDayOfWeek.toUpperCase(), 1, null, 3, 3);
                }
                if (i < quantity - 1) {
                    this.addFormFeed();
                }
            }
            this.cutPaper(this.CutTypes.FULL, true);
            this.sendMessage();
        };
    }]);